import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../../components/ui/card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { FileText } from 'lucide-react';
import { REQUEST_TYPES } from '../constants';

/**
 * Requests by Type Widget
 * Horizontal bar chart showing request count by type
 * Shows all types even if zero count
 */
export function RequestsByTypeWidget({ dsrs = [] }) {
  // Build count map
  const countByType = {};
  REQUEST_TYPES.forEach(type => {
    countByType[type.value] = 0;
  });

  dsrs.forEach(dsr => {
    if (dsr.request_type && countByType.hasOwnProperty(dsr.request_type)) {
      countByType[dsr.request_type]++;
    }
  });

  // Create chart data
  const chartData = REQUEST_TYPES.map(type => ({
    type: type.label,
    count: countByType[type.value],
    value: type.value
  }));

  // Custom tooltip with better contrast
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-slate-900 dark:bg-slate-100 text-white dark:text-slate-900 px-3 py-2 rounded text-sm border border-primary shadow-lg">
          <p className="font-semibold">{payload[0].payload.type}</p>
          <p>{payload[0].value} {payload[0].value === 1 ? 'request' : 'requests'}</p>
        </div>
      );
    }
    return null;
  };

  const maxCount = Math.max(...chartData.map(d => d.count), 1);

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <FileText className="h-5 w-5 text-primary" />
          Requests by Type
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="w-full h-80">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={chartData}
              layout="vertical"
              margin={{ top: 5, right: 30, left: 150, bottom: 5 }}
            >
              <CartesianGrid strokeDasharray="3 3" stroke="currentColor" horizontal={false} opacity={0.2} />
              <XAxis type="number" stroke="currentColor" style={{ fontSize: '12px' }} opacity={0.7} />
              <YAxis
                dataKey="type"
                type="category"
                stroke="currentColor"
                style={{ fontSize: '12px' }}
                width={140}
                opacity={0.7}
              />
              <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(26, 127, 100, 0.1)' }} />
              <Bar dataKey="count" fill="#1a7f64" radius={[0, 4, 4, 0]} isAnimationActive={true}>
                {chartData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={entry.count > 0 ? '#1a7f64' : 'rgba(226, 232, 240, 0.5)'}
                  />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
}

export default RequestsByTypeWidget;
